import { useWalletPkh } from '@/src/hooks/useWalletPkh';
import { useAppStore, useTokensStore, useWalletStore } from '@/src/store/global/index';
import { CardanoWallet } from '@/src/types';
import { isEmulator } from '@/src/lib/SmartDB/Commons/Constants/constants';
import { CARDANO_WALLETS } from '@/src/lib/SmartDB/Commons/Constants/wallets';
import { signOut, useSession } from 'next-auth/react';
import { useEffect, useState } from 'react';
import useWalletActions from '../WalletConnector/useWalletActions';
import { useLocalStorage } from '@/src/hooks/useLocalStorage';

export default function useWalletInfo() {
    //--------------------------------------
    const [isRefreshing, setIsRefreshing] = useState(true);
    useEffect(() => {
        setIsRefreshing(false);
    }, []);
    //--------------------------------------
    const { data: session, status } = useSession();
    //--------------------------------------
    const { userPkh } = useWalletPkh();
    //--------------------------------------
    const walletStore = useWalletStore();
    const appStore = useAppStore();
    const tokensStore = useTokensStore();
    //--------------------------------------
    const { handleClickToggleAdminMode, handleClickToggleDontPromtForSigning, handleToggleIsHide } = useWalletActions();
    //--------------------------------------
    const [wallet, setWallet] = useState<CardanoWallet | undefined>(undefined);
    //--------------------------------------
    useEffect(() => {
        if (walletStore.isConnected === true) {
            if (isEmulator || walletStore.info?.isWalletFromSeed === true || walletStore.info?.isWalletFromKey === true) {
                const wallet = CARDANO_WALLETS.find((wallet) => wallet.wallet === 'eternl');
                setWallet(wallet);
            } else {
                const wallet = CARDANO_WALLETS.find((wallet) => wallet.wallet === walletStore.info?.walletName);
                setWallet(wallet);
            }
        }
    }, [walletStore.isConnected]);
    //--------------------------------------

    return {
        isRefreshing,
        appStore,
        walletStore,
        tokensStore,
        session,
        status,
        handleToggleIsHide,
        handleClickToggleAdminMode,
        handleClickToggleDontPromtForSigning,
        wallet,
    };
}
//--------------------------------------
